module.exports = __webpack_public_path__ + "img/ctrl-u2-stub-1.8c086237.svg";